export const OC = [
	{
		pageTitle: 'Zakres ochrony',
		pageContent: (
			<>
				<p>
					Przedmiotem ubezpieczenia jest odpowiedzialność cywilna
					ratowników WOPR za szkody na osobie oraz szkody w mieniu
					wyrządzone osobom trzecim w związku z wykonywaniem czynności
					zawodowych.
				</p>
				<h4>Zakres ubezpieczenia OC obejmuje w szczególności:</h4>
				<ul>
					<li>
						szkody w mieniu i na osobie będące następstwem czynu
						niedozwolonego w granicach odpowiedzialności ustawowej
						lub niewykonania lub nienależytego wykonania
						zobowiązania, w tym odpowiedzialność materialna
						pracownika wynikająca z przepisów art. 114-122 Kodeksu
						Pracy regulujących odpowiedzialność pracownika za szkodę
						wyrządzoną pracodawcy oraz odpowiedzialność materialna
						pracownika za mienie powierzone (w tym pojazdy
						mechaniczne) z obowiązkiem zwrotu albo do wyliczenia
						wynikająca z przepisów art. 124-127 Kodeksu Pracy.
						Szkody wyrządzone w pojazdach mechanicznych, pojazdach
						niepodlegających obowiązkowi ubezpieczenia lub
						jednostkach pływających są objęte ochroną do sublimitu
						50.000 PLN na jeden i wszystkie wypadki w okresie
						ubezpieczenia;
					</li>
					<li>
						szkody wyrządzone w wyniku rażącego niedbalstwa, a także
						w przypadku, jeżeli szkoda została wyrządzona przez
						ubezpieczonego lub osoby, za które ponosi on
						odpowiedzialność, w stanie po użyciu alkoholu lub w
						stanie nietrzeźwości albo po użyciu środków
						odurzających, substancji psychotropowych lub środków
						zastępczych w rozumieniu przepisów o przeciwdziałaniu
						narkomanii;
					</li>
					<li>
						szkody wyrządzone w związku z udziałem lub prowadzeniem
						szkolenia;
					</li>
					<li>
						szkody wyrządzone w związku z obstawą kolonii,
						półkolonii lub innych zorganizowanych wyjazdów
						wypoczynkowych o podobnym charakterze;
					</li>
					<li>
						szkody wyrządzone innym ratownikom wodnym lub pozostałym
						osobom świadczącym pracę lub wykonującym usługę na rzecz
						WOPR;
					</li>
					<li>
						szkody w postaci uszkodzenia, zniszczenia, zaginięcia
						lub utraty akt i innych dokumentów związanych z
						wykonywaniem czynności zawodowej (sublimit 100.000 PLN
						na jeden i wszystkie wypadki w okresie ubezpieczenia);
					</li>
					<li>
						szkody w mieniu otaczającym, powstałe w trakcie
						wykonywania czynności załadunku lub wyładunku;
					</li>
					<li>
						szkody powstałe w związku z uchybieniami natury
						organizacyjnej, administracyjnej, porządkowej;
					</li>
					<li>
						szkody wyrządzone wskutek przeniesienia chorób zakaźnych
						zgodnie z Klauzulą nr 4 do Warunków Ubezpieczenia;
					</li>
					<li>
						szkody związane z naruszeniem przez osoby ubezpieczone
						dóbr osobistych osób trzecich, w tym przepisów o
						ochronie danych osobowych (w szczególności RODO) zgodnie
						z Klauzulą nr 2 do Warunków Ubezpieczenia,
					</li>
					<li>
						ryzyko utraty mienia osób trzecich, przyjętego w pieczę,
						pod dozór lub kontrolę osób objętych ubezpieczeniem,
						zgodnie z Klauzulą nr 6 do Warunków Ubezpieczenia
						(sublimit 20.000 PLN na jeden i wszystkie wypadki w
						okresie ubezpieczenia).
					</li>
				</ul>
			</>
		),
	},
	{
		pageTitle: 'Zakres terytorialny',
		pageContent: (
			<>
				<p>
					Ubezpieczenie obejmuje zdarzenia zaistniałe na terytorium
					Polski. Warunkiem odpowiedzialności ubezpieczyciela jest
					zajście wypadku ubezpieczeniowego (wadliwe działalnie lub
					zaniechanie, tj. przyczyna szkody) w okresie ubezpieczenia,
					niezależnie od momentu powstania lub ujawnienia się szkody
					oraz zgłoszenia roszczenia z tego tytułu przed upływem
					terminu przedawnienia roszczeń.
				</p>
				<h4>
					W razie potrzeby, za opłatą składki dodatkowej, zakres
					ochrony może zostać rozszerzony zgodnie z Klauzulą nr 1 do
					Warunków Ubezpieczenia o odpowiedzialność cywilną za szkody
					wyrządzone osobom trzecim na terenie całego świata z
					wyłączeniem USA i Kanady.
				</h4>
			</>
		),
	},
	{
		pageTitle: 'Informacje dodatkowe',
		pageContent: (
			<>
				<p>
					Wszelkie informacje o ubezpieczeniu odpowiedzialności
					cywilnej, w tym wyłączenia i ograniczenia odpowiedzialności
					ubezpieczyciela, znajdziesz w:
				</p>
				<ul>
					<a
						href="/downloads/zalacznik1-ugu-program-ubezpieczenia-dla-ratownikow-wopr.pdf"
						target="_blank"
					>
						<li>Programie ubezpieczeń </li>
					</a>
					<a
						href="/downloads/oc-koszty-ochrony-prawnej-wu.pdf"
						target="_blank"
					>
						<li>
							Warunkach Ubezpieczenia odpowiedzialności cywilnej z
							tytułu wykonywania czynności zawodowych (B), kod:
							OC/OW060/2108
						</li>
					</a>
				</ul>
			</>
		),
	},
];

export const OP = [
	{
		pageTitle: 'Zakres ochrony',
		pageContent: (
			<>
				<p>
					Przedmiotem ubezpieczenia jest pokrycie lub zwrot
					niezbędnych i prawnie uzasadnionych kosztów ochrony prawnej
					w celu ochrony interesów prawnych ubezpieczonego związanych
					z wykonywaniem zawodu ratownika WOPR. Klauzula kosztów
					ochrony prawnej obejmuje każdy etap ochrony interesów
					prawnych ubezpieczonego, tj. zarówno na etapie przedsądowym,
					jak i w postępowaniach przed właściwymi sądami lub organami
					w każdym możliwym charakterze oraz w wewnętrznym
					postępowaniu dyscyplinarnym.
				</p>
				<h4>
					Zakresem klauzuli kosztów ochrony prawnej objęte są koszty
					poniesione w związku z:
				</h4>
				<ul>
					<li>
						ochroną interesów prawnych ubezpieczonego w
						postępowaniach cywilnych, egzekucyjnych,
						administracyjnych, karnych, w sprawach o wykroczenie i
						dyscyplinarnych (dotyczących odpowiedzialności
						zawodowej), pozostających w związku z wykonywaniem przez
						ubezpieczonego czynności służbowych związanych z
						niewykonaniem bądź nienależytym wykonaniem zawodu
						ratownika WOPR;
					</li>
					<li>
						dochodzeniem przez ubezpieczonego własnych roszczeń
						odszkodowawczych z tytułu czynów niedozwolonych lub
						roszczeń z tytułu naruszenia dóbr osobistych powstałych
						w związku z wykonywaniem przez ubezpieczonego zawodu
						ratownika WOPR;
					</li>
					<li>
						ochroną ubezpieczonego w zakresie prawa karnego i
						wykroczeń lub dochodzeniem przez ubezpieczonego roszczeń
						z tytułu popełnienia wobec ubezpieczonego przestępstwa
						zniesławienia lub znieważenia w związku z wykonywaniem
						przez ubezpieczonego zawodu ratownika WOPR;
					</li>
					<li>
						ochroną interesów prawnych ubezpieczonego w zakresie
						umów związanych z wykonywaniem zawodu ratownika WOPR;
					</li>
					<li>
						ochroną interesów prawnych ubezpieczonego w zakresie
						ochrony danych osobowych.
					</li>
				</ul>
				<h4>
					Zakres ubezpieczenia obejmuje następujące koszty ochrony
					prawnej:
				</h4>
				<ul>
					<li>
						koszty usług podmiotów uprawnionych do świadczenia
						pomocy prawnej, tj. koszty jednego adwokata lub radcy
						prawnego z tytułu zastępstwa procesowego lub obrony,
						pokrywane do trzykrotnej wysokości ustalonej zgodnie z
						odpowiednimi przepisami regulującymi wysokość
						minimalnego wynagrodzenia za czynności adwokata lub
						radcy prawnego, jeśli takie obowiązują;
					</li>
					<li>
						opinie prawne zlecone przez ubezpieczonego w następstwie
						zgłoszonego do niego roszczenia wynikłego z niewykonania
						lub nienależytego wykonania czynności zawodowych
						ratownika WOPR;
					</li>
					<li>
						koszty mediacji na każdym etapie (pozasądowej,
						przedsądowej, sądowej);{' '}
					</li>
					<li>
						koszty postępowania przed sądem polubownym, w tym
						wynagrodzenie i zwrot wydatków arbitra, koszty
						postępowania wszczętego na skutek skargi o uchylenie
						wyroku sądu polubownego oraz koszty wszelkich postępowań
						prowadzonych wskutek środków zaskarżenia określonych w
						art. 1208 par. 3 k.p.c. oraz koszty postępowania o
						uznanie albo stwierdzenie wykonalności wyroku sądu
						polubownego lub ugody przed nim zawartej;
					</li>
					<li>
						koszty sądowe, łącznie z należnościami dla świadków oraz
						koszty postępowania egzekucyjnego;
					</li>
					<li>
						koszty związane z uzyskaniem opinii biegłych lub
						rzeczoznawców albo innych dokumentów stanowiących środki
						dowodowe;
					</li>
					<li>
						koszty podróży do sądu, jeżeli stawiennictwo
						ubezpieczonego było obowiązkowe;{' '}
					</li>
					<li>
						koszty zasądzone od ubezpieczonego na rzecz strony
						przeciwnej, Skarbu Państwa (w tym również koszty
						zasądzone przez sąd z tytułu udziału w postępowaniu
						karnym oskarżyciela posiłkowego) lub innej strony
						przeciwnej;
					</li>
					<li>
						pozostałe koszty i opłaty sądowe lub administracyjne, o
						ile służą one ochronie praw ubezpieczonego w związku z
						prowadzonym postępowaniem;
					</li>
					<li>
						zwrotne koszty poręczenia majątkowego przewidzianego dla
						uniknięcia tymczasowego aresztowania.
					</li>
				</ul>
			</>
		),
	},
	{
		pageTitle: 'Zakres terytorialny',
		pageContent: (
			<>
				<p>
					Ochroną ubezpieczeniową na podstawie niniejszej klauzuli
					objęte są koszty ochrony prawnej, poniesione przez
					ubezpieczonego w postępowaniu wszczętym na terenie Polski w
					okresie ubezpieczenia, o ile dotyczy ono czynności
					zawodowych ubezpieczonego przyjętych do ubezpieczenia na
					podstawie niniejszej umowy. W razie wątpliwości za datę
					wszczęcia postępowania uważa się chwilę, w której właściwy
					organ, urząd lub funkcjonariusz podjął pierwszą czynność
					wobec ubezpieczonego, nawet jeśli nie była ona potwierdzona
					na piśmie i nie stanowiła formalnego wszczęcia postępowania
					w świetle obowiązujących przepisów.
				</p>
				<p>
					W przypadku zaprzestania korzystania z ochrony
					ubezpieczeniowej w wyniku przejścia na emeryturę lub rentę
					ubezpieczonemu przysługuje dodatkowy okres na zgłaszanie
					roszczeń, wynoszący 36 miesięcy od daty zakończenia okresu
					ubezpieczenia.
				</p>
			</>
		),
	},
	{
		pageTitle: 'Informacje dodatkowe',
		pageContent: (
			<>
				<p>
					Wszelkie informacje o klauzuli kosztów ochrony prawnej, w
					tym wyłączenia i ograniczenia odpowiedzialności
					ubezpieczyciela, znajdziesz w:
				</p>
				<ul>
					<a
						href="/downloads/zalacznik1-ugu-program-ubezpieczenia-dla-ratownikow-wopr.pdf"
						target="_blank"
					>
						<li>Programie ubezpieczeń</li>
					</a>
					<a
						href="/downloads/oc-koszty-ochrony-prawnej-wu.pdf"
						target="_blank"
					>
						<li>
							Warunkach Ubezpieczenia odpowiedzialności cywilnej z
							tytułu wykonywania czynności zawodowych (B), kod:
							OC/OW060/2108.
						</li>
					</a>
				</ul>
			</>
		),
	},
];

export const NNW = [
	{
		pageTitle: 'Zakres ochrony',
		pageContent: (
			<>
				<p>
					Przedmiotem ubezpieczenia są następstwa nieszczęśliwych
					wypadków doznanych przez ubezpieczonego.
				</p>
				<h4>Zakres ubezpieczenia NNW obejmuje:</h4>
				<ul>
					<li>
						śmierć w wyniku nieszczęśliwego wypadku (NW) do sumy
						ubezpieczenia określonej dla wybranego wariantu ochrony;
					</li>
					<li>
						trwały uszczerbek na zdrowiu w wyniku NW do sumy
						ubezpieczenia określonej dla wybranego wariantu ochrony
						– system świadczeń proporcjonalnych;
					</li>
					<li>
						koszty nabycia wyrobów medycznych po NW do sumy
						ubezpieczenia 6 000 PLN;
					</li>
					<li>
						koszty przeszkolenia zawodowego osób z
						niepełnosprawnością po NW do sumy ubezpieczenia 6 000
						PLN;
					</li>
					<li>
						koszty odbudowy stomatologicznej po NW do sumy
						ubezpieczenia 5 000 PLN. Ubezpieczyciel nie zwraca
						kosztów zakupu implantów i implantacji;
					</li>
					<li>
						koszty jednorazowego świadczenia z tytułu trwałej utraty
						zdolności w wyniku NW do wykonywania pracy w
						dotychczasowym zawodzie (pod warunkiem, że rozpoczęła
						się w okresie ochrony ubezpieczeniowej i trwa co
						najmniej 6 miesięcy i będzie utrzymywać się co najmniej
						przez kolejne 24 miesiące liczone od daty jej
						rozpoczęcia) do sumy ubezpieczenia określonej dla
						wybranego wariantu ochrony;
					</li>
					<li>
						assistance medyczny po NW, w tym wizyta lekarza, wizyta
						pielęgniarki, dostarczenie do miejsca pobytu leków
						przepisanych przez lekarza, transport z miejsca pobytu
						ubezpieczonego do placówki medycznej, transport z
						placówki medycznej do miejsca pobytu ubezpieczonego,
						pomoc domowa, pomoc psychologiczna, opieka nad dziećmi,
						organizacja opieki nad psami i kotami ubezpieczonego
						znajdującymi się w jego domu, informacja o służbie
						zdrowia, powiadomienie o zaistniałym zdarzeniu rodziny
						oraz zakładu pracy ubezpieczonego, korepetycje, funeral
						assistance (limity ilościowe oraz kwotowe dla
						poszczególnych usług assistance są określone w Ogólnych
						Warunkach Ubezpieczenia).
					</li>
				</ul>
				<h4>W zakresie ochrony mieszczą się również:</h4>
				<ul>
					<li>następstwa zawału serca;</li>
					<li>następstwa udaru mózgu;</li>
					<li>
						następstwa utraty przytomności o nieustalonej
						przyczynie;
					</li>
					<li>
						nieszczęśliwe wypadki powstałe w następstwie uprawiania
						sportów klasy niższego oraz wyższego ryzyka;
					</li>
					<li>
						klauzula włączająca szkody powstałe po spożyciu alkoholu
						– z ochrony ubezpieczeniowej nie jest wyłączony
						nieszczęśliwy wypadek, kiedy ubezpieczony był pod
						wpływem alkoholu, którego poziom we krwi przekroczył
						0,2‰ lub 0,1 mg alkoholu w 1 dm3 w wydychanym powietrzu.
						Wyjątkiem jest sytuacja, gdy ubezpieczony prowadził
						wszelkiego rodzaju pojazdy i był sprawcą wypadku, gdzie
						zastosowanie mają obowiązujące przepisy dla kierowców
						pojazdów kraju na terenie, którego wydarzył się
						nieszczęśliwy wypadek.
					</li>
				</ul>
				<h4>
					W razie potrzeby, za opłatą składki dodatkowej, zakres
					ochrony może zostać rozszerzony o:
				</h4>
				<ul>
					<li>zwrot kosztów leczenia i rehabilitacji;</li>
					<li>
						zasiłek dzienny z tytułu czasowej, pełnej niezdolności
						do pracy lub nauki (365 dni);
					</li>
					<li>klauzulę uciążliwego leczenia;</li>
					<li>
						klauzulę naruszenia nietykalności cielesnej
						ubezpieczonego;
					</li>
					<li>
						klauzulę ubezpieczenia na wypadek zakażenia HIV i/lub
						WZW.
					</li>
				</ul>
			</>
		),
	},
	{
		pageTitle: 'Zakres terytorialny',
		pageContent: (
			<>
				<p>
					Zakres ubezpieczenia NNW obejmuje ochroną wypadki
					ubezpieczeniowe zaistniałe na całym świecie. Czas, w jakim
					działa ochrona, jest uzależniony od wybranego wariantu
					ubezpieczenia, tj.:
				</p>
				<ul>
					<li>
						wariant całodobowy – obejmuje odpowiedzialność
						ubezpieczyciela za następstwa nieszczęśliwych wypadków
						doznanych przez ubezpieczonego podczas wykonywania
						określonej w umowie ubezpieczenia pracy zawodowej, w
						drodze do i z pracy oraz w życiu prywatnym;
					</li>
					<li>
						wariant ograniczony – obejmuje odpowiedzialność
						ubezpieczyciela za następstwa nieszczęśliwych wypadków
						doznanych przez ubezpieczonego podczas wykonywania pracy
						zawodowej oraz w drodze do i z pracy.
					</li>
				</ul>
			</>
		),
	},
	{
		pageTitle: 'Informacje dodatkowe',
		pageContent: (
			<>
				<p>
					Wszelkie informacje o ubezpieczeniu NNW, w tym wyłączenia i
					ograniczenia odpowiedzialności ubezpieczyciela, znajdziesz
					w:
				</p>
				<ul>
					<a
						href="/downloads/zalacznik1-ugu-program-ubezpieczenia-dla-ratownikow-wopr.pdf"
						target="_blank"
					>
						<li>Programie ubezpieczeń</li>
					</a>
					<a
						href="/downloads/nnw-owu-biznespodroz.pdf"
						target="_blank"
					>
						<li>
							Ogólnych Warunkach Ubezpieczenia Biznes & Podróż z
							dnia 1 sierpnia 2021 r. (kod: PAT/OW071/2108)
						</li>
					</a>
				</ul>
			</>
		),
	},
];
